import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { firstResponseError, pruneServerErrors } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import Dialog from '@/components/dialogs/Dialog';
import vocabularyComponents from '../helper';
import { hideSaveVocabulary, updateVocabulary, updateActiveVocabularyProperties } from '../actions';

const SaveVocabularyDialog = ({
  hide,
  putData,
  theme,
  updateProperties,
  vocabulary,
}) => {
  const {
    FormInput, modalSize, validator, smallWizard,
  } = vocabularyComponents[vocabulary.grouping];

  const checkForErrors = () => {
    const validationErrors = validator(vocabulary);
    updateProperties({ updateErrors: validationErrors });

    return validationErrors;
  };

  const submitForm = () => {
    const validationErrors = checkForErrors();
    if (validationErrors.length === 0) {
      putData();
    }
  };

  return (
    <Dialog
      className={clsx('aridhia-save-vocabulary-dialog', { smallwizard: smallWizard })}
      error={firstResponseError(vocabulary.updateErrors)}
      icon="font"
      inProgress={vocabulary.updateStatus === states.PENDING}
      minimumDataEntryMet={vocabulary.name}
      onClose={hide}
      onDismiss={() => updateProperties({ updateErrors: pruneServerErrors(vocabulary.updateErrors) })}
      onSave={submitForm}
      saveMessageId="actions.modify"
      size={modalSize}
      theme={theme}
      title={vocabulary.name}
    >
      <FormInput submitForm={submitForm} />
    </Dialog>
  );
};

const mapStateToProps = ({
  vocabularies: { activeVocabulary },
}) => ({ vocabulary: activeVocabulary });

const mapDispatchToProps = {
  updateProperties: updateActiveVocabularyProperties,
  hide: hideSaveVocabulary,
  putData: updateVocabulary,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveVocabularyDialog);
